import Vue from "vue";
import Vuex from "vuex";
import _ from "lodash";
import backupModule from "./backups/index.js";

import actions from "./actions";
import getters from "./getters";

import mutations from "./mutations";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    backups: backupModule
  },
  state: {
    currentGroupID: "all",
    currentReloadActionID: '',
    currentReloadProgress: {},
    sites: [],
    appInfo: {},
    panelUpdateInfo: {},
    settings: {},
    groups: [],
    selectedSites: [],
    selectedGroups: [],
    panelHistory: [],
    sitesUpdates: [],
    pluginsAndThemes: [],
    backups: {},
    clientPluginUpdateSites: [],
    lastReloadTime: null,
    reloadStats:{},
    installedAddons:{},
    favorites: {
      plugins: [],
      themes: [],
      themeGroups: [],
      pluginGroups: []
    }
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  strict: true
});



// WEBPACK FOOTER //
// ./src/store/index.js